module.exports = __webpack_public_path__ + "static/media/privacy-policy.774a8c9e.pdf";